import Layout from "@/views/layout";

const inspectionRouter = {
  path: "/inspection",
  name: "Inspection",
  component: Layout,
  meta: { title: "检测模块" },
  children: [
    {
      path: "inspectionFirst",
      name: "InspectionFirst",
      component: () => import("@/views/inspection/inspectionFirst"),
      meta: { title: "逢车必检" }
    },
    {
      path: "inspectionSecond",
      name: "InspectionSecond",
      component: () => import("@/views/inspection/inspectionSecond"),
      meta: { title: "逢车必检" }
    }
  ]
};

export default inspectionRouter;
